import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useMonarch } from '@redventures/cohesion-utils-react';
import { OfferMerchMetadata } from '~/types/offerObject';
import { setOfferMerchData } from '~/redux/actions/common';

interface MonarchRuleDataWrapper {
  data?: OfferMerchMetadata;
  isLoading: boolean;
}

/**
 * Hook to get global offer merchandising data from Monarch rule
 * Uses useMonarchRule to fetch data and dispatches it to Redux for backward compatibility
 */
export const useGlobalOfferMerchData = (): MonarchRuleDataWrapper => {
  const dispatch = useDispatch();

  const { result, isLoading } = useMonarch();
  const ruleData = (result?.source?.cartOfferMerchandisingNgcBau?.value ?? {}) as { data?: OfferMerchMetadata };

  const dataObj = useMemo<MonarchRuleDataWrapper>(() => {
    return {
      data: ruleData?.data,
      isLoading,
    };
  }, [result, isLoading]);

  // Dispatch data to Redux for other hooks to consume (backward compatibility)
  // Only update Redux if data exists and is not empty
  useEffect(() => {
    if (dataObj.data && Object.keys(dataObj.data).length > 0) {
      dispatch(setOfferMerchData(dataObj.data));
    }
  }, [dataObj.data, dispatch]);

  return dataObj;
};

export default useGlobalOfferMerchData;
